module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"create-order":"Create Order","order-created":"Order created","failed-create-order":"Failed to create order"}}')
  delete Component.options._Ctor
}
